var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/clinic-surrounding.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-32c1d028!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/clinic-surrounding.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ClinicSurrounding.vue
// module id = 307
// module chunks = 1